module.exports = __webpack_public_path__ + "static/img/Unbenannt-8.804df7be.svg";